import { createI18n } from "@sagot/i18n";
import { applyStoredTheme } from "@sagot/ui";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/app";
import "./index.css";

applyStoredTheme();

async function bootstrap() {
  const root = document.getElementById("root");
  if (!root) throw new Error("Missing #root element");
  const i18n = await createI18n();
  // Screen readers pick the voice from <html lang>: keep it on the language the UI is in (index.html says "en").
  const syncLanguage = () => {
    document.documentElement.lang = i18n.language;
  };
  syncLanguage();
  i18n.on("languageChanged", syncLanguage);
  createRoot(root).render(
    <StrictMode>
      <App i18n={i18n} />
    </StrictMode>,
  );
}

void bootstrap();
